import { Navigate, Outlet } from "react-router-dom";
import { HomeLoading } from "@/components/home-loading";
import BillingWarningPopup from "@/components/billing-warning-popup";
import { useAuth } from "@babackapp/auth-client/hooks";
import { useDatadogAuthTracking } from "@/hooks/use-datadog-auth-tracking";
import ShopCommandPalette from "@/components/shop-command-palette";
import { useCommandPalette } from "@/hooks/use-command-palette";
import BillingWarningCarrierSetupPopup from "@/components/billing-warning-carrier-setup";

export default function AppLayout() {
  const auth = useAuth();
  const commandPalette = useCommandPalette();
  useDatadogAuthTracking();

  if (auth.isAuthenticating) return <HomeLoading />;

  if (!auth.isAuthenticated) return <Navigate to={"/auth/sign-in"} replace />;

  return (
    <>
      <ShopCommandPalette
        isOpen={commandPalette.isOpen}
        onClose={commandPalette.close}
      />
      <BillingWarningPopup />
      <BillingWarningCarrierSetupPopup />
      <Outlet />
    </>
  );
}
